export const themeOptions = [
    {label: <div className="flex items-center"><img className="h-5 mr-1" src={process.env.PUBLIC_URL  + '/lightmode_light.png'}/> Light</div>, 
    value: 'active4d', 
    key: 'active4d',
    name: 'light'},
    {label: <div className="flex items-center"><img className="h-5 mr-1" src={process.env.PUBLIC_URL  + '/lightmode_dark.png'}/> Dark</div>, 
    value: 'oceanic-next', 
    key: 'oceanic-next',
    name: 'dark'}
]